import React, { useState, useEffect } from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import BankServices from "../../../Services/QRCodeServices/BankServices/BankServices";
import { Row, Col } from "reactstrap";
import Select from "react-select";

const paymentOptions = [
  { label: "Bank", value: 1 },
  { label: "Cash", value: 2 },
  { label: "Card", value: 3 },
  { label: "Online", value: 4 },
  { label: "Credit", value: 5 },
];

const creditOptions = [
  { label: "Cash", value: 2 },
  { label: "Card", value: 3 },
  { label: "Online", value: 4 },
  { label: "Bank", value: 1 },
];

// Validation schema using Yup
const validationSchema = Yup.object({
  name: Yup.string().required("Name is required"),
  phoneNumber: Yup.string()
    .matches(/^[0-9]{10}$/, "Phone number must be 10 digits")
    .required("Phone number is required"),
  address: Yup.string(),
  type: Yup.number().required("Payment type is required"),
  remarks: Yup.string(),
  // BankId: Yup.number("please enter number").required("Need Bank Id"),
  BankId: Yup.number()
    .typeError("Please enter a number")
    .when(["type", "paymentMethod"], {
      is: (type, paymentMethod) => type === "1" || paymentMethod === "1",
      then: (schema) => schema.required("Need Bank Id"),
      otherwise: (schema) => schema.notRequired(),
    }),

  paidAmount: Yup.number()
    .typeError("Please enter a valid amount")
    .min(0, "Paid amount cannot be negative")
    .when("type", {
      is: "5",
      then: (schema) => schema.required("Paid amount is required"),
      otherwise: (schema) => schema.notRequired(),
    }),

  paymentMethod: Yup.number()
  .when("paidAmount", {
    is: (value) => !!value && value !== 0,
    then: (schema) => schema.required("Payment method is required"),
    otherwise: (schema) => schema.notRequired(),
  }),

  menuOrderId: Yup.number().when("type", {
    is: "5",
    then: (schema) => schema.required("Menu Order ID is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
});

const PaymentModal = ({
  isOpen,
  toggle,
  onSubmit,
  loading,
  orderId,
  netAmount,
}) => {
  console.log(orderId);
  const [bankList, setBankList] = useState([]);
  const [showPaymentOptionCredit, setShowPaymentOptionCredit] = useState(false);

  const formik = useFormik({
    initialValues: {
      phoneNumber: "",
      address: "",
      name: "",
      type: 2, // Default to Cash
      remarks: "",
      printBill: false,
      BankId: "",
      paidAmount: 0,
      paymentMethod: 0,
      menuOrderId: orderId,
      totalBillAmount: netAmount,
    },
    validationSchema: validationSchema,
    onSubmit: (values, { resetForm }) => {
      if (orderId && formik.values.type == 5) {
        formik.values.menuOrderId = orderId;
      }

      if (netAmount && formik.values.type == 5) {
        formik.values.totalBillAmount = netAmount;
      }

      console.log(values);
      onSubmit(values);

      resetForm();
      toggle();
    },
  });

  const resetModal = () => {
    formik.resetForm();
    toggle();
  };

  const fetchBanks = async () => {
    try {
      const res = await BankServices.getList();

      const transformedArray = res?.map((item) => ({
        label: item.name,
        value: item.id,
      }));

      setBankList(transformedArray);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (
      formik.values.type === "1" ||
      (formik.values.paidAmount > 0 && formik.values.paymentMethod == 1)
    ) {
      console.log("heelo");
      fetchBanks();
    } else {
      setBankList([]);
    }
  }, [
    formik.values.type,
    formik.values.paidAmount,
    formik.values.paymentMethod,
  ]);

  useEffect(() => {
    if (formik.values.paidAmount > 0) {
      setShowPaymentOptionCredit(true);
    } else {
      setShowPaymentOptionCredit(false);
    }
  }, [formik.values.paidAmount]);

  return (
    <Modal isOpen={isOpen} toggle={resetModal}>
      <form onSubmit={formik.handleSubmit}>
        <ModalHeader toggle={toggle}>Payment Details</ModalHeader>
        <ModalBody>
          <div className="mb-3">
            <label className="form-label">Name</label>
            <input
              type="text"
              className={`form-control ${
                formik.touched.name && formik.errors.name ? "is-invalid" : ""
              }`}
              name="name"
              value={formik.values.name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.name && formik.errors.name && (
              <div className="invalid-feedback">{formik.errors.name}</div>
            )}
          </div>

          <div className="mb-3">
            <label className="form-label">Phone Number</label>
            <input
              type="tel"
              className={`form-control ${
                formik.touched.phoneNumber && formik.errors.phoneNumber
                  ? "is-invalid"
                  : ""
              }`}
              name="phoneNumber"
              value={formik.values.phoneNumber}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.phoneNumber && formik.errors.phoneNumber && (
              <div className="invalid-feedback">
                {formik.errors.phoneNumber}
              </div>
            )}
          </div>

          <div className="mb-3">
            <label className="form-label">Address</label>
            <input
              type="text"
              className="form-control"
              name="address"
              value={formik.values.address}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          </div>

          <Row className="mb-3">
            <Col xs={bankList.length > 0 && 6}>
              <label className="form-label">Payment Type</label>
              <select
                className={`form-select ${
                  formik.touched.type && formik.errors.type ? "is-invalid" : ""
                }`}
                name="type"
                value={formik.values.type}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              >
                {paymentOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
              {formik.touched.type && formik.errors.type && (
                <div className="invalid-feedback">{formik.errors.type}</div>
              )}
            </Col>

            {formik.values.type == 5 && ( //when credit is selected ask for a how much customer wants to pay
              <>
                <Col md={6} className=" justify-content-end">
                  <label for="paidAmount">Payed Amount</label>
                  <input
                    type="number"
                    className="form-control"
                    name="paidAmount"
                    value={formik.values.paidAmount} //put intial to zero
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />

                  {formik.touched.paidAmount && formik.errors.paidAmount && (
                    <div className="invalid-feedback">
                      {formik.errors.paidAmount}
                    </div>
                  )}
                </Col>

                {showPaymentOptionCredit && ( //when credit is slected and custmoer is paying some money show him the method of payment
                  <Col md={6} className="">
                    <label for="paymentMethod">
                      Select Credit Payment Method
                    </label>

                    <Select
                      id="paymentMethod"
                      name="paymentMethod"
                      options={creditOptions}
                      onChange={(option) =>
                        formik.setFieldValue(
                          "paymentMethod",
                          option ? option.value : ""
                        )
                      }
                      onBlur={() =>
                        formik.setFieldTouched("paymentMethod", true)
                      }
                      value={bankList.find(
                        (option) => option.value === formik.values.paymentMethod
                      )}
                      placeholder="Select Payment Method"
                      isClearable
                      className={
                        formik.touched.paymentMethod &&
                        formik.errors.paymentMethod
                          ? "is-invalid"
                          : ""
                      }
                    />
                    {formik.touched.paymentMethod &&
                      formik.errors.paymentMethod && (
                        <div className="invalid-feedback">
                          {formik.errors.paymentMethod}
                        </div>
                      )}
                  </Col>
                )}
              </>
            )}

            {((bankList.length > 0 && formik.values.type === "1") ||
              (formik.values.type === "5" &&
                formik.values.paymentMethod == 1 &&
                formik.values.paidAmount > 0 &&
                bankList.length > 0)) && ( //when bank is selected
              <Col md={6} className="">
                <label for="BankId">Select bank</label>
                <Select
                  id="BankId"
                  name="BankId"
                  options={bankList}
                  onChange={(option) =>
                    formik.setFieldValue("BankId", option ? option.value : "")
                  }
                  onBlur={() => formik.setFieldTouched("BankId", true)}
                  value={bankList.find(
                    (option) => option.value === formik.values.BankId
                  )}
                  placeholder="Select the Bank"
                  isClearable
                  className={
                    formik.touched.BankId && formik.errors.BankId
                      ? "is-invalid"
                      : ""
                  }
                />
                {formik.touched.BankId && formik.errors.BankId && (
                  <div className="invalid-feedback">{formik.errors.BankId}</div>
                )}
              </Col>
            )}

            <Col></Col>
          </Row>

          <div className="mb-3">
            <label className="form-label">Remarks</label>
            <textarea
              className="form-control"
              name="remarks"
              value={formik.values.remarks}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              rows="2"
            />
          </div>
          <div className="mb-3 form-check">
            <input
              type="checkbox"
              className="form-check-input"
              id="printBill"
              name="printBill"
              checked={formik.values.printBill}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            <label className="form-check-label" htmlFor="printBill">
              Print Bill
            </label>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={resetModal}>
            Cancel
          </Button>
          <Button color="success" type="submit" disabled={loading}>
            {loading ? "Processing..." : "Confirm Payment"}
          </Button>
        </ModalFooter>
      </form>
    </Modal>
  );
};

export default PaymentModal;
